import { Subject } from 'rxjs';
import { catalogService } from './service';

export class CatalogStore {
  constructor(rootStore) {
    this.rootStore = rootStore;
    this.subject = new Subject();
    this.catalog = null;
    this.category = null;
    this.subCategories = null;
    this.categoryItems = null;
    this.productDetails = null;
    this.userSearchResults = null;
    // Флаги загрузки: loading — каталог/категория/товар, searchLoading — поиск.
    this.loading = false;
    this.searchLoading = false;
    // Счётчик запросов поиска: поздний ответ раннего запроса не должен
    // перетирать результаты более нового.
    this._searchSeq = 0;
  }

  _emit() { this.subject.next(this); }

  setCatalog(v) { this.catalog = v; this._emit(); }
  setCategory(v) { this.category = v; this._emit(); }
  setSubCategories(v) { this.subCategories = v; this._emit(); }
  setCategoryItems(v) { this.categoryItems = v; this._emit(); }
  setProductDetails(v) { this.productDetails = v; this._emit(); }
  setUserSearchResults(v) { this.userSearchResults = v; this._emit(); }

  resetCatalog() {
    this.catalog = null;
    this.category = null;
    this.subCategories = null;
    this.categoryItems = null;
    this._emit();
  }

  get categories() { return this.catalog ? this.catalog.categories : null; }
  get generalProducts() { return this.catalog ? this.catalog.items : null; }

  async getCatalog() {
    this.loading = true;
    this._emit();
    try {
      const res = await catalogService.getCatalog();
      this.setCatalog(res);
      return res;
    } finally {
      this.loading = false;
      this._emit();
    }
  }

  async getCategoryItems(categoryId, q) {
    this.loading = true;
    this._emit();
    try {
      const res = await catalogService.getCatalog({ categoryId, q });
      this.setCategoryItems(res.items);
      this.setCategory(res.category);
      this.setSubCategories(res.categories);
      return res;
    } finally {
      this.loading = false;
      this._emit();
    }
  }

  async getProductDetails(itemId) {
    this.loading = true;
    this._emit();
    try {
      const res = await catalogService.getProductDetails(itemId);
      this.setProductDetails(res.item);
      return res;
    } finally {
      this.loading = false;
      this._emit();
    }
  }

  async getUserSearchResults(q) {
    const seq = ++this._searchSeq;
    this.searchLoading = true;
    this._emit();
    try {
      const res = await catalogService.getCatalog({ q });
      // Применяем только ответ самого свежего запроса (out-of-order защита).
      if (seq === this._searchSeq) this.setUserSearchResults(res.items);
      return res;
    } finally {
      if (seq === this._searchSeq) {
        this.searchLoading = false;
        this._emit();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/stores/catalogStore/index.js